import { useContext } from "react"
import { ContextOperacion, ContextOperacionType } from "../RefactorLayout"

export const useOperacion = () => useContext<ContextOperacionType>(ContextOperacion)
